/** Separate route in each app so the combined schedule can be evaluated and removed without a navigation cutover. */
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { DomainType, TenantStatus } from '@jms/model';
import { clientPaths, PortalClientAuthorizeGuard } from '@jms/tenant/module.jms.authorisation';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';

/** Tenant authentication comes from its shell; both APIs independently enforce their domain rights. */
export const workTaskScheduleRoutes: Routes = [
  {
    path: clientPaths.WorkTaskSchedule,
    title: 'Work Task Schedule (experimental)',
    loadComponent: () => import('./page').then(module => module.WorkTaskSchedulePageComponent),
    canActivate: [(route: ActivatedRouteSnapshot) => {
      if (ConfigService.environment.domainType === DomainType.ClientPortal) return inject(PortalClientAuthorizeGuard).canLoad(route);
      return true;
    }],
    data: {
      restrictions: [TenantStatus.Ready],
    },
  },
];
